import { STORAGE_KEYS } from '@/shared/constants/storage-keys';

import { DEFAULT_LOCALE, LOCALE_OPTIONS, type Locale } from './types';

/** Same key as STORAGE_KEYS.UI_LOCALE so boot purge does not wipe the preference. */
export const LOCALE_STORAGE_KEY = STORAGE_KEYS.UI_LOCALE;

export function readLocalePreference(
  storage?: Pick<Storage, 'getItem'>,
): Locale {
  try {
    const saved = storage?.getItem(LOCALE_STORAGE_KEY);
    return (
      LOCALE_OPTIONS.find((option) => option.code === saved)?.code ??
      DEFAULT_LOCALE
    );
  } catch {
    return DEFAULT_LOCALE;
  }
}

export function saveLocalePreference(
  locale: Locale,
  storage?: Pick<Storage, 'setItem'>,
): void {
  try {
    storage?.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // Language switching still works if browser storage is unavailable.
  }
}
